import { isManifestLevelCorrectionField } from "encamp-shared/src/waste/discrepancyFieldMeta";
import {
  computeManualValue,
  manualValueError,
} from "routes/Customer/Waste/Manifests/resolveWithValue.helpers";

import { CorrectionTarget, ManifestOption } from "./CorrectionManifestPicker";

export type CorrectionFieldDraft = {
  field: string;
  target: CorrectionTarget;
  correctValue: string;
  codes: string[];
  selectionLabel: string;
};

export type CorrectionDraft = {
  manifest: ManifestOption | null;
  fields: CorrectionFieldDraft[];
};

export const EMPTY_CORRECTION_DRAFT: CorrectionDraft = { manifest: null, fields: [] };

export type NewCorrection = CorrectionTarget & { field: string; correctValue: string };

/** Every changed field must be complete and belong to the selected manifest. */
export function completedCorrections(draft: CorrectionDraft): NewCorrection[] | null {
  if (!draft.manifest || draft.fields.length === 0) return null;
  const corrections: NewCorrection[] = [];
  for (const item of draft.fields) {
    if (item.target.processedManifestId !== draft.manifest.id) return null;
    if (!isManifestLevelCorrectionField(item.field) && !item.target.wasteLineUnifiedId) return null;
    const correctValue = computeManualValue(item.field, item.correctValue, item.codes);
    if (manualValueError(item.field, correctValue)) return null;
    corrections.push({ ...item.target, field: item.field, correctValue });
  }
  return corrections;
}
